import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React, { useRef } from 'react';
import { IStyle } from 'Styles';
import DropImageSettingsDropdown from './DropImageSettingsDropdown';
import { useDropImageSettings } from 'components/well/hooks';

interface Props {
  customizeSettingsClassName?: string;
  disabled: boolean;
}

const DropImageSettings = (props: Props) => {
  const { customizeSettingsClassName, disabled } = props;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const dropdownWrapperRef = useRef<HTMLDivElement>(null);

  const onMenuClick = () => {
    if (!disableDropImageSettings && !disabled) {
      setIsMenuOpen((prev) => !prev);
    }
  };

  const {
    setDefaultRegionCaptureProfile,
    disableDropImageSettings,
    imageSettingText,
    imageSettingsPills,
    titleTip,
    deleteSingleDropSetting,
    imageSettingsList,
  } = useDropImageSettings();

  return (
    <div id='commandpanel-exptools-dropimagesettings-wrapper' 
      className={`flex flex-row w-[90%] ${
        disableDropImageSettings || disabled
          ? 'pointer-events-none cursor-none opacity-30'
          : ''
      }`}
    >
      <div id='commandpanel-exptools-dropimagesettings-header' className="flex w-1/3 align-center" style={styles.imageSettingHeading}>
        Imaging Setting
      </div>
      <div id='commandpanel-exptools-dropimagesettings-content'
        className="flex flex-row w-full border border-[#999999] rounded-sm cursor-pointer"
        onClick={onMenuClick}
        ref={dropdownWrapperRef}
      >
        <div
          id={`commandpanel-exptools-dropimagesettings-${titleTip}`}
          className="flex flex-row inputFieldDetails border-none w-[85%] h-[100%]"
          title={titleTip}
        >
          <div className="flex w-full">
            {imageSettingsPills?.map((value, i) => (
              <div  id={`commandpanel-exptools-dropimagesettings-pill-${value}`}
                key={`actBanner${i}`}
                className={`flex justify-between w-full m-1 text-[14px] rounded-full bg-[#DEE2E6]`}
              >
                <div className="flex w-3/4 mt-2 ml-2">
                  <label>{value.length > 8 ? `${value.slice(0, 8)}...` : value}</label>
                </div>
                <div id={`commandpanel-exptools-dropimagesettings-pillremove-${value}`} className="flex w-1/4 gap-2 justify-center align-center">
                  {
                    <RMCustomButton
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteSingleDropSetting(value);
                      }}
                      iconProps={{ name: 'CrossRounded', fill: '#737373' }}
                      iconClass={`rounded-sm`}
                      isDisabled={disabled}
                    />
                  }
                </div>
              </div>
            ))}
            {
              <label className="mt-1">
                {imageSettingText && imageSettingText.length && imageSettingText}
              </label>
            }
          </div>
          <div id="commandpanel-exptools-dropimagesettings-text" 
            className="flex justify-start w-[15%] items-center text-lg">
            {imageSettingsList.length > 2
              ? ` + ${imageSettingsList.length - 2 }`
              : ''}
          </div>
        </div>
        <div id="commandpanel-exptools-dropimagesettings-dropdownbutton"
          className="flex justify-center w-[15%] items-center text-[14px]"
          style={styles.select}
        >
          <DropImageSettingsDropdown 
            setIsMenuOpen={setIsMenuOpen}
            wrapperRef={dropdownWrapperRef}
            isMenuOpen={isMenuOpen}
            customizeSettingsClassName={customizeSettingsClassName}
            imageSettingsList={imageSettingsList}
            setDefaultRegionCaptureProfile={setDefaultRegionCaptureProfile}
          />
        </div>
      </div>
    </div>
  );
};

export default DropImageSettings;

const styles: IStyle = {
  select: {
    borderLeft: '1px solid #DEE2E6',
  },
  imageSettingHeading: {
    paddingInline: '1%',
  },
};
